import React from "react";

import { DateTime } from "luxon";

type DateTypeProps = {
  values: Date[];
};

export const DateType = (props: DateTypeProps) => {
  if (props.values.length > 1) {
    return (
      <ul style={{ textAlign: "left", paddingLeft: 0 }}>
        {props.values.map((value, index) => (
          <li data-anchor="user-attribute-date" key={index}>
            {DateTime.fromJSDate(value).toFormat("dd/MM/yyyy")}
          </li>
        ))}
      </ul>
    );
  }
  return (
    <div data-anchor="user-attribute-date">
      {DateTime.fromJSDate(props.values[0]).toFormat("dd/MM/yyyy")}
    </div>
  );
};
